import axios from 'axios';
import * as Sentry from "@sentry/react";

const axiosEmailInstance = axios.create({
  baseURL: process.env.REACT_APP_NODEMAILER_API_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json'
  }, 
});

// Request interceptor
axiosEmailInstance.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    Sentry.captureMessage('Nodemailer API Error:', error.response || error.message);
    return Promise.reject(error);
  }
);

// Response interceptor for logging/error handling
axiosEmailInstance.interceptors.response.use(
  (response) => response, // Success handler
  (error) => {
    Sentry.captureMessage('Nodemailer API Error:', error.response || error.message);
    return Promise.reject(error); 
  }
);

export default axiosEmailInstance;